export default "__VITE_ASSET__0624fab0__"